<template>
  <div class="page activity-rule">
    <navigation class="header">规则说明</navigation>
    <div class="body">
      <div class="section" v-for="(item, index) in rules" :key="index">
        <div class="title">
          {{ item.title }}
        </div>
        <div class="desc" v-html="item.desc"/>
      </div>
    </div>
    <footer>活动所有解释权归天美贷所有</footer>
  </div>
</template>

<script>
export default {
  name: 'secKill-rule',
  data () {
    return {
      start: Number(this.$route.query.start),
      end: Number(this.$route.query.end),
      rules: [
        {
          title: '活动内容',
          desc: '购买小美VIP尊享版，会员有效期内每30天可免费领取1次会员（10选1）'
        },
        {
          title: '活动时间',
          desc: '会员有效期内具备领取资格'
        }
      ]
    }
  }
}
</script>

<style lang="less">
@import "../../../assets/less/mixin.less";

.page.activity-rule {
    background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .header {
        flex-shrink: 0;
    }
    .body {
        flex: 1;
        flex-shrink: 0;
        margin: 40px 40px 0;
        background: #fff;
        border-radius: 30px;
        padding: 30px 30px 100px;
        .section {
            .title {
                padding-top: 50px;
                font-size: 32px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 45px;
            }
            .desc {
                border-radius: 16px;
                background-color: #fff;
                padding: 20px 0;
                font-size: 26px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 40px;
                margin-top: 10px;
            }
        }
    }

    footer {
        flex-shrink: 0;
        text-align: center;
        margin-top: 65px;
        margin-bottom: 45px;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #763E12;
        line-height: 30px;
    }
}
</style>
